import JoinFlow from './JoinFlow';
import CreateFlow from './CreateFlow';
import React, { useState } from 'react';
import { useCurrentMember } from '../../../redux/selector';
import { ModalProps } from 'antd/lib/modal/Modal';
import CenterLayout from '../../vendorlink-views/components/CenterLayout';
import TrackingFullScreenModal from '../components/TrackingFullScreenModal';

type OnboardingModalProps = Omit<ModalProps, 'onCancel'> & {
  onClose?: () => void;
};

enum FLOW {
  CREATE_COMMUNITY,
  FIND_AN_EXISTING_COMMUNITY,
}

const OnboardingModal: React.FC<OnboardingModalProps> = ({ onClose, ...rest }) => {
  const currentMember = useCurrentMember();
  const [flow, setFlow] = useState(FLOW.FIND_AN_EXISTING_COMMUNITY);

  const closeInternal = () => {
    setFlow(FLOW.FIND_AN_EXISTING_COMMUNITY);
    onClose && onClose();
  };
  return (
    <TrackingFullScreenModal
      name="UI/ONBOARDING/MODAL"
      properties={() => ({ currentMemberId: currentMember?.memberId })}
      {...rest}
      onCancel={closeInternal}
    >
      <CenterLayout>
        <div style={{ height: 480 }}>
          {flow === FLOW.FIND_AN_EXISTING_COMMUNITY ? (
            <JoinFlow switchFlow={() => setFlow(FLOW.CREATE_COMMUNITY)} onComplete={closeInternal} />
          ) : (
            <CreateFlow switchFlow={() => setFlow(FLOW.FIND_AN_EXISTING_COMMUNITY)} onComplete={closeInternal} />
          )}
        </div>
      </CenterLayout>
    </TrackingFullScreenModal>
  );
};

export default OnboardingModal;
